<div class="report-preview-container">
  <div *ngIf="loading" class="loading">
    <span>Loading report preview...</span>
  </div>

  <div *ngIf="error" class="error-message">
    Error: {{ error }}
  </div>

  <ng-container *ngIf="!loading && selectedVersion">
    <div class="preview-content">
      <div *ngIf="selectedVersion" class="preview-container">
        <div class="preview-header">
          <div class="d-flex gap-2 align-items-center justify-content-between w-100">
            <div>
              <div class="selected-filename">
                {{ selectedVersion.fileName }}
              </div>
              <div class="selected-version-date">
                {{ getReportDate(selectedVersion.createdDate) }}
              </div>
            </div>

            <div class="d-flex gap-2 align-items-center">
              <button
                class="btn btn-outline-primary"
                (click)="downloadVersion(selectedVersion, $event)"
                [disabled]="isDownloading"
                data-testid="report-preview-download-version">
                <span *ngIf="!isDownloading" class="fa fa-download"></span>
                <span *ngIf="isDownloading" class="fa fa-spinner fa-spin"></span>
                {{ isDownloading ? 'Downloading...' : 'Download' }}
              </button>

              <button
                class="btn btn-outline-primary"
                (click)="onPrintClick(selectedVersion, $event)"
                [disabled]="isPrinting"
                data-testid="report-preview-on-print-click">
                <span *ngIf="!isPrinting" class="fa fa-print"></span>
                <span *ngIf="isPrinting" class="fa fa-spinner fa-spin"></span>
                {{ isPrinting ? 'Printing...' : 'Print' }}
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="pdfSrc" class="preview-frame-container">
          <div *ngIf="loading" class="pdf-loading">
            <span class="fa fa-spinner fa-spin"></span>
            <span>Loading PDF preview...</span>
          </div>

          <pdf-viewer
            *ngIf="!loading"
            [src]="pdfSrc"
            [render-text]="true"
            [original-size]="false"
            [show-all]="true"
            [fit-to-page]="true"
            [zoom]="1"
            (error)="onPdfError($event)"
            style="width: 100%; height: 800px;"
          ></pdf-viewer>
        </div>

        <div *ngIf="!pdfSrc && !loading" class="no-preview">
          <span>Preview not available for this report version.</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>


// WEBPACK FOOTER //
// ./src/app/core/components/report-generator/report-generator-content/report-preview/report-preview.component.html